import { render, staticRenderFns } from "./QuestionImageButton.vue?vue&type=template&id=ebbc356e&scoped=true&"
import script from "./QuestionImageButton.vue?vue&type=script&lang=js&"
export * from "./QuestionImageButton.vue?vue&type=script&lang=js&"
import style0 from "./QuestionImageButton.vue?vue&type=style&index=0&id=ebbc356e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbc356e",
  null
  
)

export default component.exports